export const PaymentGatewayNames = {
    VINDI: 'Vindi',
    PAGAR_ME: 'Pagar.me',
    MERCADO_PAGO: 'MercadoPago',
    PAGSEGURO: 'PagSeguro',
    CIELO: 'Cielo',
    BSPAG: 'Bspag',
};



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/shared/enums/PaymentGatewayNames.ts